/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedSalesIndexRouteImport } from './routes/_authed/sales/index'
import { Route as AuthedReportsIndexRouteImport } from './routes/_authed/reports/index'
import { Route as AuthedRentalsIndexRouteImport } from './routes/_authed/rentals/index'
import { Route as AuthedPartiesIndexRouteImport } from './routes/_authed/parties/index'
import { Route as AuthedMovementsIndexRouteImport } from './routes/_authed/movements/index'
import { Route as AuthedLandsIndexRouteImport } from './routes/_authed/lands/index'
import { Route as AuthedClientsIndexRouteImport } from './routes/_authed/clients/index'
import { Route as AuthedCalendarIndexRouteImport } from './routes/_authed/calendar/index'

const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSalesIndexRoute = AuthedSalesIndexRouteImport.update({
  id: '/sales/',
  path: '/sales/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReportsIndexRoute = AuthedReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRentalsIndexRoute = AuthedRentalsIndexRouteImport.update({
  id: '/rentals/',
  path: '/rentals/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPartiesIndexRoute = AuthedPartiesIndexRouteImport.update({
  id: '/parties/',
  path: '/parties/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMovementsIndexRoute = AuthedMovementsIndexRouteImport.update({
  id: '/movements/',
  path: '/movements/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLandsIndexRoute = AuthedLandsIndexRouteImport.update({
  id: '/lands/',
  path: '/lands/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedClientsIndexRoute = AuthedClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCalendarIndexRoute = AuthedCalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/sign-up': typeof SignUpRoute
  '/calendar/': typeof AuthedCalendarIndexRoute
  '/clients/': typeof AuthedClientsIndexRoute
  '/lands/': typeof AuthedLandsIndexRoute
  '/movements/': typeof AuthedMovementsIndexRoute
  '/parties/': typeof AuthedPartiesIndexRoute
  '/rentals/': typeof AuthedRentalsIndexRoute
  '/reports/': typeof AuthedReportsIndexRoute
  '/sales/': typeof AuthedSalesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/sign-up': typeof SignUpRoute
  '/': typeof AuthedIndexRoute
  '/calendar': typeof AuthedCalendarIndexRoute
  '/clients': typeof AuthedClientsIndexRoute
  '/lands': typeof AuthedLandsIndexRoute
  '/movements': typeof AuthedMovementsIndexRoute
  '/parties': typeof AuthedPartiesIndexRoute
  '/rentals': typeof AuthedRentalsIndexRoute
  '/reports': typeof AuthedReportsIndexRoute
  '/sales': typeof AuthedSalesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/sign-up': typeof SignUpRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/calendar/': typeof AuthedCalendarIndexRoute
  '/_authed/clients/': typeof AuthedClientsIndexRoute
  '/_authed/lands/': typeof AuthedLandsIndexRoute
  '/_authed/movements/': typeof AuthedMovementsIndexRoute
  '/_authed/parties/': typeof AuthedPartiesIndexRoute
  '/_authed/rentals/': typeof AuthedRentalsIndexRoute
  '/_authed/reports/': typeof AuthedReportsIndexRoute
  '/_authed/sales/': typeof AuthedSalesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/sign-up'
    | '/calendar/'
    | '/clients/'
    | '/lands/'
    | '/movements/'
    | '/parties/'
    | '/rentals/'
    | '/reports/'
    | '/sales/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/sign-up'
    | '/'
    | '/calendar'
    | '/clients'
    | '/lands'
    | '/movements'
    | '/parties'
    | '/rentals'
    | '/reports'
    | '/sales'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/sign-up'
    | '/_authed/'
    | '/_authed/calendar/'
    | '/_authed/clients/'
    | '/_authed/lands/'
    | '/_authed/movements/'
    | '/_authed/parties/'
    | '/_authed/rentals/'
    | '/_authed/reports/'
    | '/_authed/sales/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignUpRoute: typeof SignUpRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/sales/': {
      id: '/_authed/sales/'
      path: '/sales'
      fullPath: '/sales/'
      preLoaderRoute: typeof AuthedSalesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/reports/': {
      id: '/_authed/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthedReportsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/rentals/': {
      id: '/_authed/rentals/'
      path: '/rentals'
      fullPath: '/rentals/'
      preLoaderRoute: typeof AuthedRentalsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/parties/': {
      id: '/_authed/parties/'
      path: '/parties'
      fullPath: '/parties/'
      preLoaderRoute: typeof AuthedPartiesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/movements/': {
      id: '/_authed/movements/'
      path: '/movements'
      fullPath: '/movements/'
      preLoaderRoute: typeof AuthedMovementsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/lands/': {
      id: '/_authed/lands/'
      path: '/lands'
      fullPath: '/lands/'
      preLoaderRoute: typeof AuthedLandsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clients/': {
      id: '/_authed/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AuthedClientsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/calendar/': {
      id: '/_authed/calendar/'
      path: '/calendar'
      fullPath: '/calendar/'
      preLoaderRoute: typeof AuthedCalendarIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedCalendarIndexRoute: typeof AuthedCalendarIndexRoute
  AuthedClientsIndexRoute: typeof AuthedClientsIndexRoute
  AuthedLandsIndexRoute: typeof AuthedLandsIndexRoute
  AuthedMovementsIndexRoute: typeof AuthedMovementsIndexRoute
  AuthedPartiesIndexRoute: typeof AuthedPartiesIndexRoute
  AuthedRentalsIndexRoute: typeof AuthedRentalsIndexRoute
  AuthedReportsIndexRoute: typeof AuthedReportsIndexRoute
  AuthedSalesIndexRoute: typeof AuthedSalesIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedCalendarIndexRoute: AuthedCalendarIndexRoute,
  AuthedClientsIndexRoute: AuthedClientsIndexRoute,
  AuthedLandsIndexRoute: AuthedLandsIndexRoute,
  AuthedMovementsIndexRoute: AuthedMovementsIndexRoute,
  AuthedPartiesIndexRoute: AuthedPartiesIndexRoute,
  AuthedRentalsIndexRoute: AuthedRentalsIndexRoute,
  AuthedReportsIndexRoute: AuthedReportsIndexRoute,
  AuthedSalesIndexRoute: AuthedSalesIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  SignUpRoute: SignUpRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
